import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductModel } from "../../Api/Models/product.model";
import { riderService } from "../../Api/Services/RiderService";
import "photoswipe/dist/photoswipe.css";

import { Gallery, Item } from "react-photoswipe-gallery";
import { RiderProfileLayoutContextInterface } from "./RiderProfileLayout";
import { useOutletContext } from "react-router-dom";
import { useInfoModal } from "../../Context/InfoModalProvider";
import { RiderProductModel } from "../../Api/Models/rider.model";
import { LongArrowRightIcon } from "../../Components/Icons/LongArrowRightIcon";
import { TickFilledIcon } from "../../Components/Icons/TickFilledIcon";
import { ModalSuccessIcon } from "../../Components/Icons/ModalSuccessIcon";
import { ArrowUpIcon } from "../../Components/Icons/ArrowUpIcon";
import { ArrowDownIcon } from "../../Components/Icons/ArrowDownIcon";
import { CheckIcon } from "../../Components/Icons/CheckIcon";

interface AssignNewGearItemProps {
  setAssignNewGearItem: React.Dispatch<React.SetStateAction<boolean>>;
  fetchGears: CallableFunction;
  riderGears: RiderProductModel[];
}

const AssignNewGearItem: React.FunctionComponent<AssignNewGearItemProps> = ({
                                                                              setAssignNewGearItem,
                                                                              fetchGears,
                                                                              riderGears,
                                                                            }) => {
  const { t } = useTranslation();
  const { showInfo } = useInfoModal();
  const { rider } = useOutletContext<RiderProfileLayoutContextInterface>();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [results, setResults] = useState<ProductModel[]>([]);
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
      null
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [page] = useState<number>(0);

  const quantityRef = useRef<HTMLInputElement | null>(null);
  const dateRef = useRef<HTMLInputElement | null>(null);

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  //const lazyLoadingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const [saving, setSaving] = useState<boolean>(false);


  type PickedItemsBarStatusType = "opened" | "minimized" | null;
  const [pickedItemsBarStatus, setPickedItemsBarStatus] = useState<PickedItemsBarStatusType>(
      null
  );

  const [selectedVariation, setSelectedVariation] = useState<string | null>(null);

  const handleVariationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedVariation(event.target.value);
  };

  const [categories, setCategories] = useState<
      Array<{ id: number; name: string; first_image: string | null; products_count: number }>
  >([]);

    const [selectedCategory, setSelectedCategory] = useState<{
        id: number;
        name: string;
    } | null>(null);



    useEffect(() => {
        const getCategory = async () => {
            setLoading(true);
            try {
                const categories = await riderService.getCategorys(rider.riderId, searchTerm);
                setCategories(
                    categories.map((category: { id: number; name: string; first_image: string | null; products_count: number }) => ({
                        ...category
                    }))
                );
            } finally {
                setLoading(false);
            }
        };

        getCategory();
    }, [rider.riderId, searchTerm]);




    const [filteredCategoryId, setFilteredCategoryId] = useState<number | null>(null);
    const handleCategoryClick = (categoryId: number, categoryName: string) => {
        setFilteredCategoryId((prev) => {
            const newCategoryId = prev === categoryId ? 0 : categoryId;
            searchProducts(searchTerm, 0, newCategoryId);
            return newCategoryId;
        });
        setSelectedCategory({ id: categoryId, name: categoryName });
    };





    useEffect(() => {
    let callback: CallableFunction | null = null;

    callback = () => {
      searchProducts(searchTerm, page);
    };

    timeoutRef.current = setTimeout(() => (callback ? callback() : null), 1000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    //eslint-disable-next-line
  }, [searchTerm, page]);

  /*useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  useEffect(() => {
    const handleScroll = () => {
      if (lazyLoadingTimeoutRef.current) {
        clearTimeout(lazyLoadingTimeoutRef.current);
      }

      lazyLoadingTimeoutRef.current = setTimeout(() => {
        if (
            window.scrollY + window.innerHeight >=
            document.documentElement.scrollHeight
        ) {
          setPage((prev) => prev + 1);
        }
      }, 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (lazyLoadingTimeoutRef.current) {
        clearTimeout(lazyLoadingTimeoutRef.current);
      }
    };
    //eslint-disable-next-line
  }, []);*/

  useEffect(() => {
    searchProducts("");
    //eslint-disable-next-line
  }, []);

  const [assignedItems, setAssignedItems] = useState<Array<{
    productId: number;
    productImage: string;
    productName: string;
    variationName: string;
    variationId: number | null;
    assignDate: string;
    quantity: number;
    maxPerRider: number;
    category: number;
    sendable: boolean;
  }>>([]);

  const searchProducts = async (q: string, p: number = 0, c:number=0) => {
    setLoading(true);
    riderService
        .searchProducts(rider.riderId, q, p, c)
        .then((products) => {
          const updatedResults = p === 0 ? products : [...results, ...products];

          const categoryCounts: Record<number, number> = {};
          updatedResults.forEach((product) => {
            if (product.category) {
              categoryCounts[product.category] = (categoryCounts[product.category] || 0) + 1;
            }
          });

          setResults(updatedResults);
        })
        .finally(() => {
          setLoading(false);
        });
  };

    const getMaxQuantity = (
        results: ProductModel[] | undefined,
        riderGears: RiderProductModel[] | undefined,
        selectedProductId: number | null
    ) => {
        if (selectedProductId == null) return 20;

        const product = results?.find((x) => x.id === selectedProductId);
        const allowed =
            product?.maxPerRider && product.maxPerRider > 0 ? product.maxPerRider : 20;

        const alreadyAssigned =
            riderGears?.filter((x) => x.productId === selectedProductId)?.length || 0;

        return Math.max(allowed - alreadyAssigned, 0);
    };


    const handleQuantityChange = (index: number, newQuantity: number) => {
        const maxQuantity = getMaxQuantity(results, riderGears, selectedProductId);
        const safeQuantity = Math.min(Math.max(newQuantity, 1), maxQuantity);

        setAssignedItems((prevItems) =>
            prevItems.map((item, i) =>
                i === index ? { ...item, quantity: safeQuantity } : item
            )
        );
    };


    const [quantity, setQuantity] = useState<number>(1);

    const handleQuantityChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
        const maxQuantity = getMaxQuantity(results, riderGears, selectedProductId);
        const newValue = Math.min(Math.max(Number(e.target.value), 1), maxQuantity);
        setQuantity(newValue);
    };

    const incrementQuantity = () => {
        const maxQuantity = getMaxQuantity(results, riderGears, selectedProductId);
        setQuantity((prev) => Math.min(prev + 1, maxQuantity));
    };

    const decrementQuantity = () => {
        setQuantity((prev) => Math.max(prev - 1, 1));
    };



    const setSendable = (productId: number) => {
    setAssignedItems((prevItems) =>
        prevItems.map((item) =>
            item.productId === productId
                ? { ...item, sendable: !item.sendable }
                : item
        )
    );
  };

  const handleAssignItem = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedProductId || !dateRef.current || !quantityRef.current) {
      return;
    }

    const newItem = {
      productId: selectedProductId,
      productImage: results.find((x) => x.id === selectedProductId)?.image ?? "",
      productName: results.find((x) => x.id === selectedProductId)?.name ?? "",
      variationName:
          results
              .find((x) => x.id === selectedProductId)
              ?.variations.find(
              (variation) => variation.id === parseInt(selectedVariation || "0")
          )?.name ?? "",
      variationId: selectedVariation ? parseInt(selectedVariation) : null,
      assignDate: dateRef.current.value,
      quantity: parseInt(quantityRef.current.value),
      maxPerRider: results.find((x) => x.id === selectedProductId)?.maxPerRider ?? 20,
      category: results.find((x) => x.id === selectedProductId)?.category ?? 0,
      sendable: true,
    };


    setAssignedItems((prevItems) => [...prevItems, newItem]);

    showInfo(
        <>
          <div className="flex justify-center mb-4"><ModalSuccessIcon /></div>
          <div className="text-center">{t("Item added to the list!")}</div>
        </>
    );
    quantityRef.current.value = "1";
    setQuantity(1);
    setSelectedCategory(null);
  };


  useEffect(() => {
    if (assignedItems.length > 0 && pickedItemsBarStatus === null) {
      setPickedItemsBarStatus("minimized");
    } else if (assignedItems.length === 0) {
      setPickedItemsBarStatus(null);
    }
    setSelectedProductId(null);
  }, [assignedItems, pickedItemsBarStatus]);


    const handleSave = async () => {
        if (saving) return;
        setSaving(true);

        const sendableItems = assignedItems
            .filter((item) => item.sendable)
            .map((item) => ({
                product_id: item.productId,
                product_variation_id: item.variationId,
                date: item.assignDate,
                quantity: item.quantity,
            }));

        if (sendableItems.length === 0) {
            showInfo(<div>{t('No items to send')}</div>);
            setSaving(false);
            return;
        }

        try {
            await riderService.assignGearItems(rider.riderId, sendableItems);

            showInfo(
                <div>
                    <div className="flex justify-center mb-4"><ModalSuccessIcon /></div>
                    <div className="text-center">{t('Items successfully assigned!')}</div>
                </div>
            );

            setAssignedItems([]);
            fetchGears();
        } catch (error) {
            showInfo(
                <div>
                    <div className="text-center text-error">
                        {t('Failed to assign items. Please try again.')}
                    </div>
                </div>
            );
            console.error("Error assigning gear items:", error);
        } finally {
            setTimeout(() => setSaving(false), 2000);
        }
    };

  const selectedProduct = results.find((x) => x.id === selectedProductId);

  return (
      <>
        <div
            className={"bottom-modal " + (!selectedProductId ? "hidden" : "")}
            tabIndex={-1}
            role="dialog"
            style={{ zIndex: 100 }}
        >
          <div className="bottom-modal__scroll-content">
            <div className="bottom-modal__body" style={{marginTop: "50px"}}>
              <form onSubmit={handleAssignItem}>

                <div className="stock-item__image">
                  <img
                      src={
                          results.find((x) => x.id === selectedProductId)?.image ?? ""
                      }
                      alt="Product"
                      style={{height: "75px"}}
                  />
                </div>

                <div className="stock-item__title heading text-center mb-2 mt-8">
                  {results.find((x) => x.id === selectedProductId)?.name ?? ""}
                </div>

                <div
                    className="text-secondary text-center mb-6">{t('Select the Rider’s size, if it’s not available you can skip it and come back later.')}</div>
                <input
                    type="hidden"
                    name="variations"
                    value=""
                />

                {selectedProduct?.variations.length ? (
                    <div className={`grid gap-3 grid-cols-${Math.min(selectedProduct?.variations.length, 4)}`}>
                      {selectedProduct?.variations.map((variation) => (
                          <div>
                            <label key={variation.id} className="choice-card">
                              <input
                                  type="radio"
                                  name="variations"
                                  value={variation.id ?? ""}
                                  onChange={handleVariationChange}
                                  required
                              />
                              <div className="choice-card__content">
                                {variation.name}
                                <div className="choice-card__marker">
                                  <TickFilledIcon/>
                                </div>
                              </div>
                            </label>
                          </div>
                      ))}
                    </div>
                ) : null}

                <div className="separator-line"></div>

                <div className="text-secondary mb-2">{t('Assign Date')}</div>

                <div className="flex gap-4 mb-4">
                  <div className="flex-1">
                    <input
                        type="date"
                        ref={dateRef}
                        placeholder={t("Date") ?? ""}
                        className="input-field"
                        required
                        defaultValue={rider.joinDate}
                        onClick={() => dateRef.current?.showPicker?.()}
                    />

                  </div>
                  <div className="">
                    <div className="order-product-variation-quantity">
                      <button
                          type="button"
                          className="order-product-variation-quantity__decrement"
                          onClick={decrementQuantity}
                      >
                        -
                      </button>
                      <input
                          className="order-product-variation-quantity__input"
                          type="number"
                          step={1}
                          min={1}
                          max={
                              ((results?.find((x) => x.id === selectedProductId)?.maxPerRider ?? 0) > 0
                                      ? results?.find((x) => x.id === selectedProductId)?.maxPerRider ?? 20
                                      : 20
                              ) - (riderGears?.filter((x) => x.productId === selectedProductId)?.length || 0)
                          }
                          ref={quantityRef}
                          value={quantity}
                          style={{width: `${Math.max(quantity.toString().length, 2)}ch`}}
                          onChange={handleQuantityChanges}
                          placeholder={t("Quantity") ?? ""}
                          required
                      />
                      <button
                          type="button"
                          className="order-product-variation-quantity__increment"
                          onClick={incrementQuantity}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-1">
                    <div
                        className="button button--light w-full"
                        onClick={() => {
                          setSelectedProductId(null);
                          setQuantity(1);
                        }}
                    >
                      {t('Back')}
                    </div>
                  </div>
                  <div className="flex-1">
                    <button type="submit" className="button w-full">
                      {t("Add")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>


        <div className="heading mb-4">{t("Add historical gear data")}</div>
        <input
            className="input-field mb-4"
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={t("Gear name") ?? ""}
        />
        <div className="grid grid-cols-2 gap-4 mb-8">
          {categories.map((category) => (
              <div
                  key={category.id}
                  className={`product-category-item cursor-pointer ${filteredCategoryId === category.id ? "selected" : ""}`}
                  onClick={() => handleCategoryClick(category.id, category.name)}
              >
                <div className="product-category-item__image">
                  <img
                      src={category.first_image || `https://via.placeholder.com/70`}
                      alt={category.name}
                      style={{
                        height: "70px",
                        objectFit: "contain",
                      }}
                  />
                </div>
                <div className="flex items-center gap-1">
                  <div className="product-category-item__title">{category.name}</div>
                  <div className="product-category-item__counter">{category.products_count}</div>
                </div>
              </div>
          ))}
        </div>


        <div>
          {loading && (
              <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,.3)",
                    zIndex: 99999999,
                    borderRadius: "10px",
                  }}
              >
                <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                >
                  <div className="loader mx-auto">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
          )}


          <button
              className="button button--light"
              type="button"
              onClick={() => setAssignNewGearItem(false)}
          >
            {t("Back")}
          </button>

          <div className="pt-4"></div>
        </div>

        {pickedItemsBarStatus && (
            <div className="picked-items-modal">
              <div className="picked-items-modal__content">

                <div className="flex gap-2 justify-between items-center mb-6">
                  <div className="color-purple">{t('Picked items')}:</div>
                  <div className="flex gap-2">
                    <div className="variation-pcs-info">
                      <div className="variation-pcs-info__size">{assignedItems.length}</div>
                      <div className="variation-pcs-info__quantity">{t('Item')}</div>
                    </div>

                    {pickedItemsBarStatus === "opened" && (
                        <div
                            className="icon-button icon-button--purple"
                            onClick={() => {
                              setPickedItemsBarStatus("minimized")
                            }}
                        >
                          <ArrowDownIcon/>
                        </div>
                    )}

                    {pickedItemsBarStatus === "minimized" && (
                        <div
                            className="icon-button"
                            onClick={() => {
                              setPickedItemsBarStatus("opened")
                            }}
                        >
                          <ArrowUpIcon/>
                        </div>
                    )}

                  </div>
                </div>

                {pickedItemsBarStatus === "opened" && (
                    <div
                        className="picked-items-modal__scroll-content mb-4"
                        style={{maxHeight: '180px'}}
                    >
                      {assignedItems.map((item, index) => (
                          <div className="product-list-card mb-4 marked" key={index}>
                            <div className="flex items-center gap-2">
                              <div className="relative">
                                <div className="product-list-card__image">
                                  <img
                                      src={item.productImage || "https://via.placeholder.com/60"}
                                      alt={item.productName}
                                  />
                                </div>
                                {item.variationName && (
                                    <div className="product-list-card__variation-name">
                                      {item.variationName || "N/A"}
                                    </div>
                                )}
                              </div>

                              <div className="w-full">
                                <div className="product-list-card__title">
                                  {item.productName || "Unknown Product"}
                                </div>
                              </div>

                              <div className="flex gap-2 items-center checkboxlist-item">
                                <select
                                    className="input-field input-field--small input-field--auto-width"
                                    value={assignedItems[index]?.quantity || 1}
                                    onChange={(e) =>
                                        handleQuantityChange(index, parseInt(e.target.value, 10))
                                    }
                                >
                                    {Array.from(
                                        { length: item.maxPerRider && item.maxPerRider > 0 ? item.maxPerRider : 20 },
                                        (_, i) => (
                                            <option value={i + 1} key={i}>
                                                {i + 1} pcs
                                            </option>
                                        )
                                    )}

                                </select>

                                <button
                                    type="button"
                                    {...(item.sendable ? {className: "product-list-card__check checked"} : {className: "product-list-card__check"})}
                                    onClick={() => setSendable(item.productId)}
                                >
                                  <CheckIcon/>
                                </button>

                              </div>

                            </div>
                          </div>
                      ))}
                    </div>
                )}
                <div className="flex gap-4">
                  <div className="flex-1">
                    <div
                        className="button button--light w-full"
                        onClick={() => {
                          setPickedItemsBarStatus(null);
                          setAssignedItems([]);
                        }}
                    >
                      {t('Cancel')}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div
                        className="button w-full"
                        onClick={handleSave}
                    >
                      {t('Save')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        )}
          {selectedCategory && (
              <div className="bottom-modal" tabIndex={-1} role="dialog" style={{ zIndex: 50 }}>
                  <div className="bottom-modal__scroll-content">
                      <div className="bottom-modal__body" style={{ marginTop: "50px" }}>
                          <h2 className="text-lg font-bold mb-4">{selectedCategory.name}</h2>
                          {results
                              .filter((product) => {
                                  if (filteredCategoryId && product.category !== filteredCategoryId) {
                                      return false;
                                  }

                                  const assignedCount =
                                      riderGears?.filter((x) => x.productId === product.id)?.length || 0;

                                  if (product.maxPerRider === 0) {
                                      return true;
                                  }

                                  const maxAssignable = (product.maxPerRider ?? 20) - assignedCount;
                                  return maxAssignable > 0;
                              })
                              .map((product) => (
                                  <div key={product.id}>
                                      <div className="product-list-card mb-4">
                                          <div className="flex items-center gap-2">
                                              <div className="relative">
                                                  <div className="product-list-card__image">
                                                      <Gallery>
                                                          <Item original={product.image ?? ""}>
                                                              {({ref, open}) => (
                                                                  <img
                                                                      onClick={open}
                                                                      src={product.image ?? ""}
                                                                      alt={product.name}
                                                                      style={{
                                                                          marginRight: "10px",
                                                                          width: "60px",
                                                                          height: "60px",
                                                                          objectFit: "contain",
                                                                      }}
                                                                  />
                                                              )}
                                                          </Item>
                                                      </Gallery>
                                                  </div>
                                              </div>
                                              <div className="flex-1">
                                                  <div className="product-list-card__title">{product.name}</div>
                                              </div>
                                              <button
                                                  className="icon-button"
                                                  onClick={() => setSelectedProductId(product.id)}
                                              >
                                                  <LongArrowRightIcon/>
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              ))}

                          <button
                              className="button button--light w-full"
                              onClick={() => {
                                  setSelectedCategory(null);
                                  setFilteredCategoryId(null);
                              }}
                          >
                              {t('Back')}
                          </button>

                      </div>
                  </div>
              </div>
          )}

      </>
  );
};

export default AssignNewGearItem;